import Head from 'next/head';
import { categoryApi } from '../../apis/CategoryApi';
import SinglePage from '../../components/About/SinglePage';
import Layout from '../../components/Layout';
import { constants } from '../../utils/constants';

const Home = (props) => {

   return (
      <Layout
         title="ABOUT - DNAP ARCHITECTURE"
         {...props}
         WrappedComponent={SinglePage}
         pageName="about"
      />
   )
}

export async function getServerSideProps({ req }) {
   let isMobileView = (req
      ? req.headers['user-agent']
      : navigator.userAgent).match(
         /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
      );

   return {
      props: {
         isMobileView: Boolean(isMobileView),
      }
   }
}

export default Home;
